import styled, { css } from "styled-components";
import P from "../../atoms/Typography/P";

export const Backdrop = styled.div`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
`;

type ContainerProps = {
  isOpen: boolean;
  backgroundColor: string;
  listType: "colors" | "text" | "interests";
};

export const Container = styled.div<ContainerProps>`
  ${({ isOpen, backgroundColor }) => css`
    z-index: ${isOpen && 10};
    width: 100%;
    height: 100%;
    display: flex;
    max-height: 38px;
    min-height: 38px;
    position: relative;
    border-radius: 12px;
    justify-content: flex-start;
    background-color: ${backgroundColor};
  `}
`;

type DropdownProps = {
  isOpen: boolean;
  textColor: string;
  borderColor: string;
  backgroundColor: string;
  listType: "colors" | "text" | "interests";
};

export const Dropdown = styled.ul<DropdownProps>`
  ${({ isOpen, textColor, borderColor, backgroundColor }) => css`
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    cursor: pointer;
    list-style: none;
    user-select: none;
    max-height: 400px;
    position: absolute;
    overflow-y: overlay;
    color: ${textColor};
    border-radius: 12px;
    flex-direction: column;
    height: ${!isOpen && "100%"};
    background-color: ${isOpen && backgroundColor};

    li {
      display: flex;
      margin: 0 16px;
      transition: none;
      padding: 20px 12px;
      align-items: center;
      border-bottom: 1px solid ${borderColor};

      &:last-of-type,
      &:first-of-type {
        border-bottom: none;
      }

      &:first-of-type {
        margin: 0;
        padding: ${isOpen ? "20px 40px 20px 20px" : "0px 40px 0px 20px"};
      }
    }
  `}
`;

export const Selected = styled.li`
  gap: 8px;
  width: 100%;
  height: 100%;
  display: flex;
  cursor: pointer;
  user-select: none;
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
  border-radius: 12px;
  align-items: center;
  justify-content: space-between;
`;

export const IconAndText = styled.div`
  gap: 16px;
  width: 100%;
  display: flex;
  flex-shrink: 0;
  align-items: center;
`;

type IconProps = {
  color: string;
};

export const Icon = styled.div<IconProps>`
  ${({ color }) => css`
    width: 40px;
    height: 40px;
    display: flex;
    flex-shrink: 0;
    border-radius: 8px;
    align-items: center;
    justify-content: center;
    background-color: ${color};

    svg {
      width: 70%;
      height: 70%;
    }
  `};
`;

type AheadIconProps = {
  isOpen: boolean;
};

export const AheadIcon = styled.div<AheadIconProps>`
  ${({ isOpen }) => css`
    width: 10px;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    transform: ${isOpen ? "rotate(-90deg)" : "rotate(90deg)"};

    svg {
      width: 100%;
    }
  `}
`;

export const Content = styled.div`
  gap: 8px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 740px) {
    flex-direction: column;
  }
`;

type ImageProps = {
  image: string;
};

export const ProjectImage = styled.div<ImageProps>`
  ${({ image }) => css`
    width: 140px;
    height: 100px;
    display: flex;
    flex-shrink: 0;
    border-radius: 20px;
    background: url(${image});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    @media (max-width: 740px) {
      display: none;
    }
  `}
`;

export const Texts = styled.div`
  gap: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const TextsDetails = styled.div`
  width: 100%;
  display: flex;
  text-align: justify;
`;

export const TextsSummary = styled.div`
  gap: 32px;
  width: 100%;
  display: flex;

  @media (max-width: 540px) {
    gap: 12px;
    flex-direction: column;
  }
`;

export const Pricing = styled(P)`
  flex-shrink: 0;
`;

export const SummaryBox = styled.div`
  gap: 8px;
  display: flex;
`;

export const SummaryIcon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }
`;

type SeeMoreProps = {
  textColor: string;
};

export const SeeMore = styled.a<SeeMoreProps>`
  ${({ textColor }) => css`
    cursor: pointer;
    text-align: center;
    margin-left: 12px;
    color: ${textColor};
    text-decoration: none;

    :hover {
      text-decoration: underline;
    }
  `}
`;
